export { SERVICE_NAME as CASHIER_PANEL_LOCATION_DETAILS_SERVICE_NAME, CashierPanelLocationDetailsService } from './cashier-panel-loaction-details.service'
export { SERVICE_NAME as CASHIER_PANEL_SERVICE_NAME, CashierPanelService  } from './cashier-panel.service'
